var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heart"},[_c('strong',{staticClass:"heart__counter"},[_vm._v(_vm._s(_vm.donations))]),_vm._v(" "),_c('span',{staticClass:"heart__copy"},[_vm._v("Messages Sent")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54713770","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppCounter.vue
// module id = null
// module chunks = 